import { useContext, useState, useEffect } from "react";
import { AppContext } from "../Context";

function ParamCollar() {
    const { state } = useContext(AppContext);
    const { dispatch } = useContext(AppContext);
    const collars = [{ id: "CollarNormal", caption: "Normal", img: "CollarNormal.svg", active: true }, { id: "CollarSemiWide", caption: "Semi Wide", img: "CollarSemiWide.svg", active: false }, { id: "CollarWide", caption: "Wide", img: "CollarWide.svg", active: false }, { id: "CollarButtonDown", caption: "Button Down", img: "CollarButtonDown.svg", active: false }, { id: "CollarHiddenButtonDown", caption: "Hidden Button Down", img: "CollarHiddenButtonDown.svg", active: false }, { id: "CollarWing", caption: "Wing", img: "CollarWing.svg", active: false }, { id: "CollarMandarian", caption: "Mandarian", img: "CollarMandarian.svg", active: false }];
    const [collar, setCollar] = useState(null);

    useEffect(() => {
        setCollar(state.collar)
    }, [state.collar]);

    function onItemClick(id) {
        setCollar(id);
        dispatch({ type: "SET_COLLAR", payload: id });
        dispatch({ type: "SET_DONE", payload: true });
    }
    return (
        <div className="paramItem">
            <div className="paramHeader">
                <div className="paramTitle">Collar</div>
            </div>
            <div className="monoList">
                {collars.map((collarType, index) => (
                    <div key={index} className="subMenuType" onClick={() => { onItemClick(collarType.id) }}>
                        <img className="fabricImg" src={`${process.env.PUBLIC_URL}/images/${collarType.img}`} />
                        <div className="subMenuLabel">{collarType.caption}</div>
                        {collar === collarType.id && (
                            <img className="tick" src={process.env.PUBLIC_URL + "/images/tick.svg"} width={20} alt="selected" />
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}
export default ParamCollar